module.exports = __webpack_public_path__ + "media/images/logos/rails.white-b7c12bf5c0149e3d9f2dd82e518dfc37.svg";